/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import ApiService from "../api-service";

class CompanyApiService extends ApiService {
  createCompany = async (data) => await this.post("/create", data);

  getCompanies = async () => await this.get("").then((res) => res.data);

  getCompanyDetail = async () =>
    await this.get("/detail").then((res) => res.data);

  updateCompanyDetail = async (data) =>
    await this.patch("/detail/update/", data).then((res) => res.data);

  updateCompany = async (id, data) =>
    await this.patch(`/${id}`, data).then((res) => res.data);

  deleteCompany = async (id) =>
    await this.delete(`/${id}`).then((res) => res.data);

  updateUserRole = async (id, role) =>
    await this.patch(`/user/${id}`, { role }).then((res) => res.data);

  getCompanyUsers = async () =>
    await this.get("/user").then((res) => res.data);

  deleteCompanyUser = async (userId) =>
    await this.delete(`/user/${userId}`).then((res) => res.data);

  resendInvitation = async (id) =>
    await this.post(`/user/${id}/resend-invitation`).then((res) => res.data);

  getCompanyLogs = async (params = {}, options = {}) =>
    await this.get("/log", params, false, options);

  getAuditLog = async (params = {}) =>
    await this.get("/audit", params).then((res) => res.data);

  getLocaleConfig = async () =>
    await this.get("/locale-config").then((res) => res.data);

  updateLocaleConfig = async (data) =>
    await this.patch("/locale-config", data).then((res) => res.data);

  /** Export audit to compressed CSV (.csv.gz). Returns { file, fileName }. */
  exportAudit = async (params = {}) => {
    const res = await this.get("/audit/export", params, false, {
      responseType: "blob",
    });
    const blob = res.data;
    let fileName = "HSE Genius-audit.csv.gz";
    const disposition = res.headers["content-disposition"];
    if (disposition && typeof disposition === "string") {
      const match = disposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      );
      if (match && match[1]) fileName = match[1].replace(/['"]/g, "").trim();
    }
    return { file: blob, fileName };
  };
}

const CompanyApi = new CompanyApiService("company");

export default CompanyApi;
